const styObj = {
  default: {
    // Invite/index
    '--invite-top-gradient': 'linear-gradient(180deg, #5f2c89 0%, #3c1683 68%, #21115f 100%)',
    '--invite-earn-text-shadow': '#c800ff',
    '--invite-hostess-btn-color': '#39156f',
    '--invite-policy-color': '#a338fc',
    '--invite-top-bg': `url(${require('./images/bg.png')})`,
    '--invite-nav-bar-bg': `url(${require('./images/nav-bar-bg.png')})`,
    // DashboardTab
    '--dashboard-withdraw-btn-bg': '#a338fc',
    '--dashboard-withdraw-btn-color': '#ffffff',
    '--dashboard-beans-got': '#a338fc',
    // HostesTab
    '--activity-card-color': `#3b1581`,
    '--activity-card-btn': `#a338fc`,
    '--invite-tab-theme-color': '#a338fc',
    '--invite-tab-step2-icon': `url(${require('./images/status-step2.png')})`,
    '--invite-tab-done-icon': `url(${require('./images/status-done.png')})`,
    '--invite-tab-checking-icon': `url(${require('./images/status-checking.png')})`,
    // CommissionTab
    '--commission-more-perf-color': '#a338fc',
    '--commission-beans-icon-size': '20px',
    '--commission-beans-icon-margin': '0 2px',
    '--commission-tab-active-color': '#a338fc',
    // InviteSearch
    '--invite-search-btn-theme': '#a338fc',
    // PercentBar
    '--percent-bar-progress-bg': '#a338fc',
    '--percent-bar-progress-color': '#a338fc',
    '--percent-bar-step-color': '#a338fc'
  },
  kiko: {
    // Invite/index
    '--invite-top-gradient': 'linear-gradient(180deg, #ff7a00 0%, #fc4e00 50%, #fc0000 100%)',
    '--invite-earn-text-shadow': '#fb2600',
    '--invite-hostess-btn-color': '#000000',
    '--invite-policy-color': '#ff8a33',
    '--invite-top-bg': `url(${require('./images/bg-kiko.png')})`,
    '--invite-nav-bar-bg': `url(${require('./images/nav-bar-bg-kiko.png')})`,
    // DashboardTab
    '--dashboard-withdraw-btn-bg': '#ffe242',
    '--dashboard-withdraw-btn-color': '#000000',
    '--dashboard-beans-got': '#ff9f57',
    // HostesTab
    '--activity-card-color': `#ff7b18`,
    '--activity-card-btn': `#ff9f57`,
    '--invite-tab-theme-color': '#ff8a33',
    '--invite-tab-step2-icon': `url(${require('./images/status-step2-kiko.png')})`,
    '--invite-tab-done-icon': `url(${require('./images/status-done-kiko.png')})`,
    '--invite-tab-checking-icon': `url(${require('./images/status-checking-kiko.png')})`,
    // CommissionTab
    '--commission-more-perf-color': '#006cae',
    '--commission-beans-icon-size': '24px',
    '--commission-beans-icon-margin': '0',
    '--commission-tab-active-color': '#ff8a33',
    // InviteSearch
    '--invite-search-btn-theme': '#ffe242',
    // PercentBar
    '--percent-bar-progress-bg': '#ff8a33',
    '--percent-bar-progress-color': '#ff8a33',
    '--percent-bar-step-color': '#ff8a33'
  }
}

export const pageCssVars = {
  methods: {
    cssVars() {
      if (this.packageName) {
        // 有配置
        if (styObj[this.packageName]) {
          return styObj[this.packageName]
        }
        // 未配置
        else {
          return styObj['default']
        }
      }
      return {}
    }
  }
}
